// src/constants/trasladosStatuses.js

export const TRANSFER_STATUSES = [
  "Programado",
  "Pre-Asignado",
  "Asignado",
  "Enterado",
  "Aceptado",
  "En Camino",
  "Esperando",
  "Iniciado",
  "Fallido",
  "FallidoXvalidar",
  "FinalizadoXvalidar",
  "Cancelado",
  "Finalizado",
];
